<template>
  <header
    class="layout-topbar border-bottom-1 surface-border flex align-items-center justify-content-between px-4 py-2 shadow-1">
    <div class="flex align-items-center gap-3">
      <!-- <Button icon="pi pi-bars" text rounded class="block md:hidden text-color" @click="$emit('toggle-sidebar')" /> -->

      <Breadcrumb :model="breadcrumbItems" class="border-none p-0 bg-transparent gap-2 mb-2 mt-2">
        <template #item="{ item }">
          <a v-if="item.route"
            class="cursor-pointer flex align-items-center gap-2 hover:text-primary transition-colors transition-duration-200 text-primary"
            @click.prevent="navigateTo(item)">
            <span v-if="item.icon" :class="item.icon" />
            <span v-if="item.label">{{ item.label }}</span>
          </a>
          <span v-else class="flex align-items-center gap-2 text-color">
            <span v-if="item.icon" :class="item.icon" />
            <span v-if="item.label">{{ item.label }}</span>
          </span>
        </template>
      </Breadcrumb>
    </div>

  </header>
</template>

<script lang="ts" setup>
import { useAuthStore } from "@/stores/AuthStore";
import { useCursoStore } from "@/stores/CursoStore";
import Breadcrumb from "primevue/breadcrumb";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const emit = defineEmits(['toggle-sidebar']);
const authStore = useAuthStore();
const cursoStore = useCursoStore();

const breadcrumbItems = computed(() => {
  const currentPath = route.path;
  const items: { label?: string; icon?: string; route?: string }[] = [
    {
      label: 'Home',
      icon: 'fa-solid fa-house',
      route: currentPath === '/' ? '' : '/'
    }
  ];

  if (route.path.includes('/eventos')) {
    items.push({ label: 'Eventos', route: currentPath === '/eventos' ? '' : '/eventos' });
  } else if (authStore.isAluno || authStore.isUserNormal) {
    if (route.path.includes('/acompanhamento')) {
      items.push({ label: 'Acompanhamento', route: currentPath === '/acompanhamento' ? '' : '/acompanhamento' });
    } else {
      items.push({ label: 'Meus Projetos', route: currentPath === '/projetos' ? '' : '/projetos' });
    }
  } else if (authStore.isOrientador) {
    if (route.path.includes('/defesas')) {
      items.push({ label: 'Revisão de Defesas', route: currentPath === '/defesas' ? '' : '/defesas' });
    } else {
      items.push({ label: 'Painel do Orientador', route: currentPath === '/painel-orientador' ? '' : '/painel-orientador' });
    }
  } else if (authStore.isCoordenador || authStore.isSecretaria || authStore.isCoordenadorTcc) {
    if (route.path.includes('/gerenciar-professores')) {
      items.push({ label: 'Gerenciar Professores', route: currentPath === '/gerenciar-professores' ? '' : '/gerenciar-professores' });
    } else if (route.path.includes('/avisos')) {
      items.push({ label: 'Central de Avisos', route: currentPath === '/avisos' ? '' : '/avisos' });
    } else if (route.path.includes('/gerenciar-normas-tcc')) {
      items.push({ label: 'Normas TCC / Links', route: currentPath === '/gerenciar-normas-tcc' ? '' : '/gerenciar-normas-tcc' });
    } else {
      items.push({ label: 'Gerenciar Trabalhos', route: currentPath === '/gerenciar-trabalhos' ? '' : '/gerenciar-trabalhos' });
    }
  } else if (authStore.isAdmin) {
    items.push({ label: 'Administração do Sistema', route: currentPath === '/admin' ? '' : '/admin' });
  }

  if (route.name === 'editor' || route.name === 'orientador-editor') {
    items.push({ label: 'Editor', route: '' });
  } else if (route.name === 'acompanhamento-detalhes' || route.name === 'coordenador-trabalho-detalhes') {
    items.push({ label: 'Detalhes', route: '' });
  } else if (route.name === 'referencias') {
    items.push({ label: 'Gerenciar Referências', route: '' });
  } else if (route.name === 'admin-templates') {
    items.push({ label: 'Gerenciar Templates', route: '' });
  } else if (route.name === 'admin-roles') {
    items.push({ label: 'Gerenciar Perfis', route: '' });
  } else if (route.name === 'admin-permissions') {
    items.push({ label: 'Gerenciar Permissões', route: '' });
  } else if (route.name === 'admin-users') {
    items.push({ label: 'Gerenciar Usuários', route: '' });
  } else if (route.name === 'admin-cursos') {
    items.push({ label: 'Gerenciar Cursos', route: '' });
  } else if (route.name === 'admin-coordenadores') {
    items.push({ label: 'Gerenciar Coordenadores', route: '' });
  } else if (route.name === 'admin-secretarias') {
    items.push({ label: 'Gerenciar Secretárias', route: '' });
  } else if (route.name === 'admin-professores') {
    items.push({ label: 'Gerenciar Professores', route: '' });
  } else if (route.name === 'admin-alunos') {
    items.push({ label: 'Gerenciar Alunos', route: '' });
  }

  if (route.name === 'conta') {
    return [
      { icon: 'pi pi-home', route: '/' },
      { label: 'Minha Conta', route: '' }
    ];
  }

  if (route.name === 'tutoriais') {
    return [
      { icon: 'pi pi-home', route: '/' },
      { label: 'Tutoriais', route: '' }
    ];
  }

  return items;
});

const navigateTo = (item: any) => {
  if (item.route) {
    router.push(item.route);
  }
};
</script>
